import { faShieldCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';


interface Props {
  className?: string
}

export const ProtectionPlanLogo = (props: Props) => (
  <div className={cs('d-flex align-items-center', props.className)}>
    <div><FontAwesomeIcon icon={faShieldCheck} className='mr-2' size="2x"/></div>
    <div style={{lineHeight: '1.1'}} className='font-weight-bold'><div>PROTECTION</div><div>PLAN</div></div>
  </div>
);
